<div class="input-group">
  @if (btnPosition() === "left") {
    <ng-container *ngTemplateOutlet="browseBtn"></ng-container>
  }
  <label
    #label
    tabindex="0"
    for="file-picker"
    class="form-control d-flex align-items-center custom-file-input"
    [ngClass]="{
      'is-invalid': isInvalid() && !isValid(),
      'is-valid': isValid() && !isInvalid(),
      disabled: disabled(),
    }">
    @if (file()?.name) {
      <span class="text-muted">{{ file()?.name }}</span>
    } @else {
      <span class="text-muted">{{ placeholderLabel() | translate }}</span>
    }
  </label>
  @if (btnPosition() === "right") {
    <ng-container *ngTemplateOutlet="browseBtn"></ng-container>
  }
  <input
    #fileInput
    type="file"
    class="d-none"
    id="file-picker"
    [accept]="acceptedFileTypes()"
    [disabled]="disabled()"
    (change)="onFileChange($event)"
    (cancel)="onCanceled()" />
</div>

<ng-template #browseBtn>
  <label class="input-group-text" for="file-picker" [ngClass]="{ disabled: disabled() }">{{
    browseBtnLabel() | translate
  }}</label>
</ng-template>
